import { useEffect } from "react";
import { db } from "./firebase";

const productArray = []

const ProductStore = () =>{
    useEffect(() =>{
        const dataGrab = db.collection("products")
        .onSnapshot((querySnapshot) =>{
            productArray.length = 0
            querySnapshot.forEach((doc) =>{
                productArray.push({
                    id: doc.data().id,
                    title: doc.data().name,
                    price: doc.data().price,
                    quantity: doc.data().quantity
                })
            })
        })
        return () => dataGrab();
    }, [])
}

const getProductData = (id) =>{
    return productArray.find(product => product.id === id)
}

export { productArray, getProductData };
export default ProductStore
